import React from 'react';
import PropTypes from 'prop-types';
import CheckoutPaymentFormDetailsForm from './CheckoutPaymentFormDetailsForm';

const fields = [
  {
    id: 'firstName',
    stateKey: 'customerDetails',
    required: true,
    autoComplete: 'billing given-name',
  },
  {
    id: 'lastName',
    stateKey: 'customerDetails',
    required: true,
    autoComplete: 'billing family-name',
  },
  {
    id: 'phoneNumber',
    stateKey: 'customerDetails',
    required: true,
    type: 'tel',
    autoComplete: 'billing tel',
  },
  {
    id: 'email',
    stateKey: 'customerDetails',
    required: true,
    type: 'email',
    autoComplete: 'email',
  },
];

const CheckoutPaymentFormDetailsB2C = ({ checkout, onChange }) => (
  <CheckoutPaymentFormDetailsForm
    checkout={checkout}
    fields={fields}
    onChange={onChange}
  />
);

CheckoutPaymentFormDetailsB2C.propTypes = {
  checkout: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default CheckoutPaymentFormDetailsB2C;
